import _ from 'lodash';
import * as DomTypeUtils from '@packages/systems/core/utils/DomTypeUtils';
import type {Context} from '../types';

// Convert invalid simple-text content nodes to spans.
export default (context: Context) => {
  const {
    node: {jsonNode},
    // eslint-disable-next-line webflow/deprecated
    fn: {__DEPRECATED__scanSubtree},
  } = context;
  const {data = {}, tag} = jsonNode;
  const isTypographic = tag && DomTypeUtils.isTypographic(tag, data);
  const VALID_TYPOGRAPHIC_CONTENT_NODES = ['a', 'strong', 'em', 'br', 'span'];

  const invalidContentNodes: Array<any> = [];

  if (isTypographic) {
    __DEPRECATED__scanSubtree(jsonNode, (child) => {
      if (
        !child.text &&
        (!child.tag || !VALID_TYPOGRAPHIC_CONTENT_NODES.includes(child.tag))
      ) {
        invalidContentNodes.push(child);
      }
    });
  }

  const originalInvalidContentNodes = _.cloneDeep(invalidContentNodes);

  return {
    needed: Boolean(invalidContentNodes.length),
    logData: {
      msg: 'Simple-text content node with disallowed tag',
      meta: {
        nodeId: jsonNode._id,
        originalInvalidContentNodes,
      },
    },
    apply: () => {
      invalidContentNodes.forEach((child) => {
        child.tag = 'span';
      });
    },
  };
};
